import React from "react";
import styled from "styled-components";
import { levelProgress } from "../../lib/authUser";
import { useLanguage } from "../../contexts/LanguageContext";

const Box = styled.div`
  display: grid;
  gap: 8px;
  min-width: 0;
  .top {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 4px 12px;
  }
  .elo {
    font-size: 32px;
    line-height: 36px;
    font-weight: 700;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
  }
  .unit {
    font-size: 14px;
    font-weight: 600;
    color: ${(p) => p.theme.colors.textMuted};
  }
  .level {
    margin-left: auto;
    font-size: 14px;
    font-weight: 600;
    color: ${(p) => p.theme.colors.textSecondary};
  }
  .bar {
    height: 4px;
    border-radius: 2px;
    background: ${(p) => p.theme.colors.surfaceHover};
    overflow: hidden;
    &::after {
      content: "";
      display: block;
      height: 100%;
      width: var(--ratio);
      border-radius: inherit;
      background: ${(p) => p.theme.colors.primary};
    }
  }
  .cap {
    font-size: 13px;
    line-height: 18px;
    color: ${(p) => p.theme.colors.textMuted};
  }
`;

/** Единое представление рейтинга: ELO, уровень и линейный прогресс до следующего уровня. */
export default function Rating({ elo }: { elo: number }) {
  const { t } = useLanguage();
  const p = levelProgress(elo);
  return (
    <Box>
      <div className="top">
        <span className="elo">{elo}</span>
        <span className="unit">{t("home.elo")}</span>
        <span className="level">{t("header.level", { value: p.level })}</span>
      </div>
      <div className="bar" style={{ "--ratio": `${p.ratio * 100}%` } as React.CSSProperties} role="presentation" />
      <div className="cap">{p.toNext === null ? t("home.max_level") : t("home.to_level", { n: p.level + 1, elo: p.toNext })}</div>
    </Box>
  );
}
